import WasmController from "react-lib/frameworks/WasmController";
import NewUserPipelineView from "issara-sdk/apis/NewUserPipelineView_apps_MEH";
import NewVsOldBreakMonthPipelineView from "issara-sdk/apis/NewVsOldBreakMonthPipelineView_apps_MEH";
import DivideAgeRangeAndGenderPipelineView from "issara-sdk/apis/DivideAgeRangeAndGenderPipelineView_apps_MEH";
import DivideAgeRangeAndGenderNewUserPipelineView from "issara-sdk/apis/DivideAgeRangeAndGenderNewUserPipelineView_apps_MEH";
import FrequencyVisitWithinSixMonthPipelineView from "issara-sdk/apis/FrequencyVisitWithinSixMonthPipelineView_apps_MEH";
import AppointmentStaffVsSelfPipelineView from "issara-sdk/apis/AppointmentStaffVsSelfPipelineView_apps_MEH";
import AppointmentSuccessPipelineView from "issara-sdk/apis/AppointmentSuccessPipelineView_apps_MEH";
import AppointmentCancellationPipelineView from "issara-sdk/apis/AppointmentCancellationPipelineView_apps_MEH";
import AppointmentCancellationThreeYearPipelineView from "issara-sdk/apis/AppointmentCancellationThreeYearPipelineView_apps_MEH";
import Encounter24HourPipelineView from "issara-sdk/apis/Encounter24HourPipelineView_apps_MEH";
import Encounter24HourQuarterPipelineView from "issara-sdk/apis/Encounter24HourQuarterPipelineView_apps_MEH";
import Encounter24HourThreeYearPipelineView from "issara-sdk/apis/Encounter24HourThreeYearPipelineView_apps_MEH";
import Appointment24HourPipelineView from "issara-sdk/apis/Appointment24HourPipelineView_apps_MEH";
import Appointment24HourQuarterPipelineView from "issara-sdk/apis/Appointment24HourQuarterPipelineView_apps_MEH";
import Appointment24HourThreeYearPipelineView from "issara-sdk/apis/Appointment24HourThreeYearPipelineView_apps_MEH";
import SaleSummaryOverviewPipelineView from "issara-sdk/apis/SaleSummaryOverviewPipelineView_apps_BIL";
import SaleSummaryOverviewThreeYearPipelineView from "issara-sdk/apis/SaleSummaryOverviewThreeYearPipelineView_apps_BIL";

import TopFivePopularProductPipelineView from "issara-sdk/apis/TopFivePopularProductPipelineView_apps_BIL";
import TopThreePopularProductThreeYearPipelineView from "issara-sdk/apis/TopThreePopularProductThreeYearPipelineView_apps_BIL";

import TopFiveProductByRevenuePipelineView from  "issara-sdk/apis/TopFiveProductByRevenuePipelineView_apps_BIL";
import TopThreeProductByRevenueThreeYearPipelineView from  "issara-sdk/apis/TopThreeProductByRevenueThreeYearPipelineView_apps_BIL";

import ProductSoldAmountPipelineView from  "issara-sdk/apis/ProductSoldAmountPipelineView_apps_BIL";
import ProductSoldRevenuePipelineView from  "issara-sdk/apis/ProductSoldRevenuePipelineView_apps_BIL";

import TopFiveServiceProviderPipelineView from  "issara-sdk/apis/TopFiveServiceProviderPipelineView_apps_BIL";
import TopThreeServiceProviderThreeYearPipelineView from  "issara-sdk/apis/TopThreeServiceProviderThreeYearPipelineView_apps_BIL";
import ServiceProviderPerformanceSummaryPipelineView from  "issara-sdk/apis/ServiceProviderPerformanceSummaryPipelineView_apps_BIL";




import CONFIG from "config/config";


import { logEvent } from "firebase/analytics";
import { param } from "jquery";

export type State = {
  MeChartSequence: {
    sequenceIndex?: string | null;
  } | null;
};

export const StateInitial: State = {
  MeChartSequence: null,
};

export type Props = {};

export type Event = { message: "RunSequence"; params: {} };

export type Data = {
  division?: number;
};

type Handler = (controller: WasmController<State, Event, Data, Props>, params?: any) => any;

export const Start: Handler = async (controller, params) => {
  controller.setState({
    MeChartSequence: {
      sequenceIndex: "Action",
    },
  });
};

export const Action: Handler = async (controller, params) => {
  console.log("Action params: ", params);
  console.log("Action controller: ", controller);
  switch (params.action) {
    case "QuerySQL":
      let data = getAPI(controller, params);
      let dataAwait = await data;
      console.log('Mock dataAwait: ', dataAwait);
      return data
    default:
      break;
  }
};

const getAPI: Handler = async (controller, params) => {
  console.log('getAPI controller: ', controller);
  console.log('getAPI params: ', params);
  let state = controller.getState();
  let divisionId = state.selectedDivision?.id
  
  if (CONFIG.MOCK_MECHART_DIVISION_ID && (state.selectedDivision?.id === CONFIG.MOCK_MECHART_DIVISION_ID)) {
    const startYearNum  = parseInt(params.startDate?.split("-")[0] || String(new Date().getFullYear()));
    console.log('getAPI startYearNum: ', startYearNum);
    const startMonthNum = parseInt(params.startDate?.split("-")[1] || "1");
    console.log('getAPI startMonthNum: ', startMonthNum);
    const endYearNum    = parseInt(params.endDate?.split("-")[0]   || String(new Date().getFullYear()));
    console.log('getAPI endYearNum: ', endYearNum);
    const endMonthNum   = parseInt(params.endDate?.split("-")[1]   || "12");
    console.log('getAPI endMonthNum: ', endMonthNum);
    const isMultiYear   = endYearNum - startYearNum >= 2;
    console.log('getAPI isMultiYear: ', isMultiYear);

    // Returns true when (yr, mo) falls within [startDate … endDate]
    const inRange = (yr: number, mo: number) =>
      yr * 100 + mo >= startYearNum * 100 + startMonthNum &&
      yr * 100 + mo <= endYearNum   * 100 + endMonthNum;

    // Fraction of months in `yr` that fall within the selected range (0..1)
    const monthFraction = (yr: number) => {
      const lo = yr === startYearNum ? startMonthNum : 1;
      const hi = yr === endYearNum   ? endMonthNum   : 12;
      return Math.max(0, hi - lo + 1) / 12;
    };

    switch (params.chart) {

      // ── new-vs-old-patient ──────────────────────────────────────────────
      case "new-vs-old-patient": {
        const DATA = [
          // 2022
          {yr:2022,mo:1, old_count:"350",new_count:"88" },{yr:2022,mo:2, old_count:"325",new_count:"72" },
          {yr:2022,mo:3, old_count:"375",new_count:"96" },{yr:2022,mo:4, old_count:"395",new_count:"102"},
          {yr:2022,mo:5, old_count:"380",new_count:"90" },{yr:2022,mo:6, old_count:"405",new_count:"108"},
          {yr:2022,mo:7, old_count:"420",new_count:"115"},{yr:2022,mo:8, old_count:"395",new_count:"100"},
          {yr:2022,mo:9, old_count:"380",new_count:"88" },{yr:2022,mo:10,old_count:"365",new_count:"80" },
          {yr:2022,mo:11,old_count:"390",new_count:"98" },{yr:2022,mo:12,old_count:"430",new_count:"125"},
          // 2023
          {yr:2023,mo:1, old_count:"390",new_count:"100"},{yr:2023,mo:2, old_count:"365",new_count:"82" },
          {yr:2023,mo:3, old_count:"420",new_count:"110"},{yr:2023,mo:4, old_count:"445",new_count:"118"},
          {yr:2023,mo:5, old_count:"425",new_count:"104"},{yr:2023,mo:6, old_count:"465",new_count:"128"},
          {yr:2023,mo:7, old_count:"480",new_count:"136"},{yr:2023,mo:8, old_count:"450",new_count:"120"},
          {yr:2023,mo:9, old_count:"430",new_count:"110"},{yr:2023,mo:10,old_count:"415",new_count:"96" },
          {yr:2023,mo:11,old_count:"445",new_count:"116"},{yr:2023,mo:12,old_count:"490",new_count:"148"},
          // 2024
          {yr:2024,mo:1, old_count:"450",new_count:"120"},{yr:2024,mo:2, old_count:"420",new_count:"98" },
          {yr:2024,mo:3, old_count:"480",new_count:"135"},{yr:2024,mo:4, old_count:"510",new_count:"142"},
          {yr:2024,mo:5, old_count:"495",new_count:"128"},{yr:2024,mo:6, old_count:"530",new_count:"155"},
          {yr:2024,mo:7, old_count:"545",new_count:"162"},{yr:2024,mo:8, old_count:"520",new_count:"148"},
          {yr:2024,mo:9, old_count:"505",new_count:"138"},{yr:2024,mo:10,old_count:"490",new_count:"125"},
          {yr:2024,mo:11,old_count:"515",new_count:"145"},{yr:2024,mo:12,old_count:"560",new_count:"170"},
          // 2025
          {yr:2025,mo:1, old_count:"486",new_count:"130"},{yr:2025,mo:2, old_count:"454",new_count:"106"},
          {yr:2025,mo:3, old_count:"518",new_count:"146"},{yr:2025,mo:4, old_count:"551",new_count:"153"},
          {yr:2025,mo:5, old_count:"535",new_count:"138"},{yr:2025,mo:6, old_count:"572",new_count:"167"},
          {yr:2025,mo:7, old_count:"589",new_count:"175"},{yr:2025,mo:8, old_count:"562",new_count:"160"},
          {yr:2025,mo:9, old_count:"545",new_count:"149"},{yr:2025,mo:10,old_count:"529",new_count:"135"},
          {yr:2025,mo:11,old_count:"556",new_count:"157"},{yr:2025,mo:12,old_count:"605",new_count:"184"},
          // 2026 Jan–Mar
          {yr:2026,mo:1, old_count:"522",new_count:"139"},{yr:2026,mo:2, old_count:"487",new_count:"113"},
          {yr:2026,mo:3, old_count:"557",new_count:"157"},
        ];
        return [{ items: DATA.filter(d => inRange(d.yr, d.mo))
          .map(({ yr, mo, ...rest }) => ({ month_index: String(mo), ...rest })) }];
      }

      // ── new-user ────────────────────────────────────────────────────────
      case "new-user": {
        if (startYearNum !== endYearNum) {
          // cross-year: return year-level totals scaled by selected months
          const YEAR_DATA = [
            {year:"2022",new_count:"980" },{year:"2023",new_count:"1150"},
            {year:"2024",new_count:"1666"},{year:"2025",new_count:"1800"},
            {year:"2026",new_count:"409" },
          ];
          return [{ items: YEAR_DATA
            .filter(d => parseInt(d.year) >= startYearNum && parseInt(d.year) <= endYearNum)
            .map(d => {
              const frac = monthFraction(parseInt(d.year));
              return { year: d.year, new_count: String(Math.round(parseInt(d.new_count) * frac)) };
            })
          }];
        }
        const MONTHLY = [
          // 2022
          {yr:2022,mo:1, new_count:"68" },{yr:2022,mo:2, new_count:"55" },
          {yr:2022,mo:3, new_count:"78" },{yr:2022,mo:4, new_count:"82" },
          {yr:2022,mo:5, new_count:"75" },{yr:2022,mo:6, new_count:"88" },
          {yr:2022,mo:7, new_count:"94" },{yr:2022,mo:8, new_count:"82" },
          {yr:2022,mo:9, new_count:"76" },{yr:2022,mo:10,new_count:"70" },
          {yr:2022,mo:11,new_count:"82" },{yr:2022,mo:12,new_count:"90" },
          // 2023
          {yr:2023,mo:1, new_count:"82" },{yr:2023,mo:2, new_count:"68" },
          {yr:2023,mo:3, new_count:"92" },{yr:2023,mo:4, new_count:"98" },
          {yr:2023,mo:5, new_count:"88" },{yr:2023,mo:6, new_count:"105"},
          {yr:2023,mo:7, new_count:"112"},{yr:2023,mo:8, new_count:"98" },
          {yr:2023,mo:9, new_count:"90" },{yr:2023,mo:10,new_count:"82" },
          {yr:2023,mo:11,new_count:"100"},{yr:2023,mo:12,new_count:"105"},
          // 2024
          {yr:2024,mo:1, new_count:"120"},{yr:2024,mo:2, new_count:"98" },
          {yr:2024,mo:3, new_count:"135"},{yr:2024,mo:4, new_count:"142"},
          {yr:2024,mo:5, new_count:"128"},{yr:2024,mo:6, new_count:"155"},
          {yr:2024,mo:7, new_count:"162"},{yr:2024,mo:8, new_count:"148"},
          {yr:2024,mo:9, new_count:"138"},{yr:2024,mo:10,new_count:"125"},
          {yr:2024,mo:11,new_count:"145"},{yr:2024,mo:12,new_count:"170"},
          // 2025
          {yr:2025,mo:1, new_count:"130"},{yr:2025,mo:2, new_count:"106"},
          {yr:2025,mo:3, new_count:"146"},{yr:2025,mo:4, new_count:"153"},
          {yr:2025,mo:5, new_count:"138"},{yr:2025,mo:6, new_count:"167"},
          {yr:2025,mo:7, new_count:"175"},{yr:2025,mo:8, new_count:"160"},
          {yr:2025,mo:9, new_count:"149"},{yr:2025,mo:10,new_count:"135"},
          {yr:2025,mo:11,new_count:"157"},{yr:2025,mo:12,new_count:"184"},
          // 2026 Jan–Mar
          {yr:2026,mo:1, new_count:"139"},{yr:2026,mo:2, new_count:"113"},
          {yr:2026,mo:3, new_count:"157"},
        ];
        return [{ items: MONTHLY.filter(d => inRange(d.yr, d.mo))
          .map(({ yr, mo, ...rest }) => ({ month_index: String(mo), ...rest })) }];
      }

      // ── age-gender ──────────────────────────────────────────────────────
      case "age-gender": {
        const DEMO: Record<number,any[]> = {
          2022:[
            {age_range:"0-18", male_count:"38", female_count:"32", unknown_count:"4" },
            {age_range:"19-24",male_count:"102",female_count:"124",unknown_count:"10"},
            {age_range:"25-34",male_count:"196",female_count:"234",unknown_count:"15"},
            {age_range:"35-44",male_count:"153",female_count:"166",unknown_count:"8" },
            {age_range:"45+",  male_count:"136",female_count:"153",unknown_count:"12"},
          ],
          2023:[
            {age_range:"0-18", male_count:"42", female_count:"35", unknown_count:"5" },
            {age_range:"19-24",male_count:"111",female_count:"135",unknown_count:"11"},
            {age_range:"25-34",male_count:"213",female_count:"255",unknown_count:"17"},
            {age_range:"35-44",male_count:"167",female_count:"181",unknown_count:"9" },
            {age_range:"45+",  male_count:"148",female_count:"167",unknown_count:"14"},
          ],
          2024:[
            {age_range:"0-18", male_count:"45", female_count:"38", unknown_count:"5" },
            {age_range:"19-24",male_count:"120",female_count:"145",unknown_count:"12"},
            {age_range:"25-34",male_count:"230",female_count:"275",unknown_count:"18"},
            {age_range:"35-44",male_count:"180",female_count:"195",unknown_count:"10"},
            {age_range:"45+",  male_count:"160",female_count:"180",unknown_count:"15"},
          ],
          2025:[
            {age_range:"0-18", male_count:"49", female_count:"41", unknown_count:"5" },
            {age_range:"19-24",male_count:"130",female_count:"157",unknown_count:"13"},
            {age_range:"25-34",male_count:"248",female_count:"297",unknown_count:"19"},
            {age_range:"35-44",male_count:"194",female_count:"211",unknown_count:"11"},
            {age_range:"45+",  male_count:"173",female_count:"194",unknown_count:"16"},
          ],
          2026:[
            {age_range:"0-18", male_count:"52", female_count:"44", unknown_count:"6" },
            {age_range:"19-24",male_count:"139",female_count:"168",unknown_count:"14"},
            {age_range:"25-34",male_count:"267",female_count:"319",unknown_count:"21"},
            {age_range:"35-44",male_count:"209",female_count:"226",unknown_count:"12"},
            {age_range:"45+",  male_count:"186",female_count:"209",unknown_count:"17"},
          ],
        };
        // Aggregate across years, scaling each year's data by the fraction of months selected
        const AGE_RANGES = ["0-18","19-24","25-34","35-44","45+"];
        const aggregated = AGE_RANGES.map(range => {
          let male = 0, female = 0, unknown = 0;
          for (let yr = startYearNum; yr <= endYearNum; yr++) {
            const frac = monthFraction(yr);
            const row = (DEMO[yr] ?? DEMO[2026]).find((r:any) => r.age_range === range);
            if (row) {
              male    += Math.round(parseInt(row.male_count)    * frac) || 0;
              female  += Math.round(parseInt(row.female_count)  * frac) || 0;
              unknown += Math.round(parseInt(row.unknown_count) * frac) || 0;
            }
          }
          return { age_range: range, male_count: String(male), female_count: String(female), unknown_count: String(unknown) };
        });
        return [{ items: aggregated }];
      }

      // ── new-user-age-gender ─────────────────────────────────────────────
      case "new-user-age-gender": {
        const DEMO: Record<number,any[]> = {
          2022:[
            {age_range:"0-18", male_count:"15",female_count:"12",unknown_count:"1"},
            {age_range:"19-24",male_count:"36",female_count:"47",unknown_count:"3"},
            {age_range:"25-34",male_count:"66",female_count:"78",unknown_count:"5"},
            {age_range:"35-44",male_count:"44",female_count:"55",unknown_count:"2"},
            {age_range:"45+",  male_count:"30",female_count:"36",unknown_count:"4"},
          ],
          2023:[
            {age_range:"0-18", male_count:"17",female_count:"14",unknown_count:"2"},
            {age_range:"19-24",male_count:"39",female_count:"51",unknown_count:"3"},
            {age_range:"25-34",male_count:"72",female_count:"85",unknown_count:"5"},
            {age_range:"35-44",male_count:"48",female_count:"60",unknown_count:"3"},
            {age_range:"45+",  male_count:"33",female_count:"39",unknown_count:"4"},
          ],
          2024:[
            {age_range:"0-18", male_count:"18",female_count:"15",unknown_count:"2"},
            {age_range:"19-24",male_count:"42",female_count:"55",unknown_count:"4"},
            {age_range:"25-34",male_count:"78",female_count:"92",unknown_count:"6"},
            {age_range:"35-44",male_count:"52",female_count:"65",unknown_count:"3"},
            {age_range:"45+",  male_count:"35",female_count:"42",unknown_count:"5"},
          ],
          2025:[
            {age_range:"0-18", male_count:"19",female_count:"16",unknown_count:"2"},
            {age_range:"19-24",male_count:"45",female_count:"59",unknown_count:"4"},
            {age_range:"25-34",male_count:"84",female_count:"99",unknown_count:"6"},
            {age_range:"35-44",male_count:"56",female_count:"70",unknown_count:"3"},
            {age_range:"45+",  male_count:"38",female_count:"45",unknown_count:"5"},
          ],
          2026:[
            {age_range:"0-18", male_count:"21",female_count:"17",unknown_count:"2"},
            {age_range:"19-24",male_count:"49",female_count:"64",unknown_count:"5"},
            {age_range:"25-34",male_count:"91",female_count:"107",unknown_count:"7"},
            {age_range:"35-44",male_count:"60",female_count:"76",unknown_count:"4"},
            {age_range:"45+",  male_count:"41",female_count:"49",unknown_count:"6"},
          ],
        };
        // Aggregate across years, scaling each year's data by the fraction of months selected
        const AGE_RANGES = ["0-18","19-24","25-34","35-44","45+"];
        const aggregated = AGE_RANGES.map(range => {
          let male = 0, female = 0, unknown = 0;
          for (let yr = startYearNum; yr <= endYearNum; yr++) {
            const frac = monthFraction(yr);
            const row = (DEMO[yr] ?? DEMO[2026]).find((r:any) => r.age_range === range);
            if (row) {
              male    += Math.round(parseInt(row.male_count)    * frac) || 0;
              female  += Math.round(parseInt(row.female_count)  * frac) || 0;
              unknown += Math.round(parseInt(row.unknown_count) * frac) || 0;
            }
          }
          return { age_range: range, male_count: String(male), female_count: String(female), unknown_count: String(unknown) };
        });
        return [{ items: aggregated }];
      }

      // ── frequency-visit-within-six-month ───────────────────────────────
      case "frequency-visit-within-six-month": {
        const MONTHLY = [
          // 2022
          {yr:2022,mo:1, f1:"60",f2:"23",f3:"13",f4:"7",f5:"3",f6:"2"},
          {yr:2022,mo:2, f1:"58",f2:"21",f3:"12",f4:"6",f5:"3",f6:"2"},
          {yr:2022,mo:3, f1:"63",f2:"24",f3:"13",f4:"7",f5:"3",f6:"2"},
          {yr:2022,mo:4, f1:"61",f2:"23",f3:"13",f4:"7",f5:"3",f6:"2"},
          {yr:2022,mo:5, f1:"59",f2:"22",f3:"12",f4:"6",f5:"3",f6:"2"},
          {yr:2022,mo:6, f1:"62",f2:"23",f3:"13",f4:"7",f5:"3",f6:"2"},
          {yr:2022,mo:7, f1:"64",f2:"24",f3:"14",f4:"7",f5:"4",f6:"2"},
          {yr:2022,mo:8, f1:"60",f2:"22",f3:"12",f4:"6",f5:"3",f6:"2"},
          {yr:2022,mo:9, f1:"58",f2:"21",f3:"12",f4:"6",f5:"3",f6:"2"},
          {yr:2022,mo:10,f1:"57",f2:"21",f3:"12",f4:"6",f5:"3",f6:"2"},
          {yr:2022,mo:11,f1:"59",f2:"22",f3:"12",f4:"7",f5:"3",f6:"2"},
          {yr:2022,mo:12,f1:"65",f2:"24",f3:"14",f4:"7",f5:"4",f6:"3"},
          // 2023
          {yr:2023,mo:1, f1:"65",f2:"25",f3:"14",f4:"7",f5:"4",f6:"2"},
          {yr:2023,mo:2, f1:"63",f2:"23",f3:"13",f4:"7",f5:"3",f6:"2"},
          {yr:2023,mo:3, f1:"68",f2:"26",f3:"14",f4:"8",f5:"4",f6:"2"},
          {yr:2023,mo:4, f1:"66",f2:"25",f3:"14",f4:"7",f5:"3",f6:"2"},
          {yr:2023,mo:5, f1:"64",f2:"24",f3:"13",f4:"7",f5:"3",f6:"2"},
          {yr:2023,mo:6, f1:"67",f2:"25",f3:"14",f4:"7",f5:"4",f6:"2"},
          {yr:2023,mo:7, f1:"69",f2:"26",f3:"15",f4:"8",f5:"4",f6:"2"},
          {yr:2023,mo:8, f1:"65",f2:"24",f3:"13",f4:"7",f5:"3",f6:"2"},
          {yr:2023,mo:9, f1:"63",f2:"23",f3:"13",f4:"7",f5:"3",f6:"2"},
          {yr:2023,mo:10,f1:"61",f2:"23",f3:"13",f4:"7",f5:"3",f6:"2"},
          {yr:2023,mo:11,f1:"64",f2:"24",f3:"13",f4:"7",f5:"3",f6:"2"},
          {yr:2023,mo:12,f1:"70",f2:"26",f3:"15",f4:"8",f5:"4",f6:"3"},
          // 2024
          {yr:2024,mo:1, f1:"71",f2:"27",f3:"15",f4:"8",f5:"4",f6:"3"},
          {yr:2024,mo:2, f1:"68",f2:"25",f3:"14",f4:"7",f5:"3",f6:"2"},
          {yr:2024,mo:3, f1:"74",f2:"28",f3:"16",f4:"8",f5:"4",f6:"3"},
          {yr:2024,mo:4, f1:"72",f2:"27",f3:"15",f4:"8",f5:"4",f6:"2"},
          {yr:2024,mo:5, f1:"70",f2:"26",f3:"14",f4:"8",f5:"4",f6:"2"},
          {yr:2024,mo:6, f1:"73",f2:"27",f3:"15",f4:"8",f5:"4",f6:"3"},
          {yr:2024,mo:7, f1:"75",f2:"28",f3:"16",f4:"8",f5:"4",f6:"3"},
          {yr:2024,mo:8, f1:"71",f2:"26",f3:"15",f4:"8",f5:"4",f6:"2"},
          {yr:2024,mo:9, f1:"69",f2:"25",f3:"14",f4:"7",f5:"4",f6:"2"},
          {yr:2024,mo:10,f1:"67",f2:"25",f3:"14",f4:"7",f5:"3",f6:"2"},
          {yr:2024,mo:11,f1:"70",f2:"26",f3:"15",f4:"8",f5:"4",f6:"3"},
          {yr:2024,mo:12,f1:"77",f2:"29",f3:"16",f4:"9",f5:"4",f6:"3"},
          // 2025
          {yr:2025,mo:1, f1:"77",f2:"29",f3:"16",f4:"9",f5:"4",f6:"3"},
          {yr:2025,mo:2, f1:"74",f2:"27",f3:"15",f4:"8",f5:"4",f6:"3"},
          {yr:2025,mo:3, f1:"80",f2:"30",f3:"17",f4:"9",f5:"4",f6:"3"},
          {yr:2025,mo:4, f1:"78",f2:"29",f3:"16",f4:"9",f5:"4",f6:"3"},
          {yr:2025,mo:5, f1:"76",f2:"28",f3:"16",f4:"8",f5:"4",f6:"3"},
          {yr:2025,mo:6, f1:"79",f2:"30",f3:"17",f4:"9",f5:"4",f6:"3"},
          {yr:2025,mo:7, f1:"81",f2:"30",f3:"17",f4:"9",f5:"4",f6:"3"},
          {yr:2025,mo:8, f1:"77",f2:"28",f3:"16",f4:"8",f5:"4",f6:"3"},
          {yr:2025,mo:9, f1:"75",f2:"28",f3:"16",f4:"8",f5:"4",f6:"3"},
          {yr:2025,mo:10,f1:"72",f2:"27",f3:"15",f4:"8",f5:"4",f6:"3"},
          {yr:2025,mo:11,f1:"76",f2:"28",f3:"16",f4:"9",f5:"4",f6:"3"},
          {yr:2025,mo:12,f1:"83",f2:"31",f3:"17",f4:"9",f5:"4",f6:"3"},
          // 2026
          {yr:2026,mo:1, f1:"82",f2:"31",f3:"17",f4:"9",f5:"4",f6:"3"},
          {yr:2026,mo:2, f1:"79",f2:"29",f3:"16",f4:"9",f5:"4",f6:"3"},
          {yr:2026,mo:3, f1:"85",f2:"32",f3:"18",f4:"10",f5:"5",f6:"3"},
        ];
        const filtered = MONTHLY.filter(d => inRange(d.yr, d.mo));
        const CATS = ["1","2","3","4","5",">5"] as const;
        const keys = ["f1","f2","f3","f4","f5","f6"] as const;
        const aggregated = CATS.map((cat, i) => ({
          frequency_category: cat,
          patient_count: String(filtered.reduce((sum, d) => sum + parseInt((d as any)[keys[i]]) || 0, 0)),
        }));
        return [{ items: aggregated }];
      }

      // ── appointment-staff-vs-self ───────────────────────────────────────
      case "appointment-staff-vs-self": {
        const MONTHLY = [
          // 2022
          {yr:2022,mo:1, self:16,staff:10},{yr:2022,mo:2, self:17,staff:11},
          {yr:2022,mo:3, self:18,staff:12},{yr:2022,mo:4, self:19,staff:13},
          {yr:2022,mo:5, self:20,staff:14},{yr:2022,mo:6, self:21,staff:15},
          {yr:2022,mo:7, self:22,staff:16},{yr:2022,mo:8, self:23,staff:17},
          {yr:2022,mo:9, self:24,staff:18},{yr:2022,mo:10,self:25,staff:19},
          {yr:2022,mo:11,self:26,staff:20},{yr:2022,mo:12,self:27,staff:21},
          // 2023
          {yr:2023,mo:1, self:18,staff:11},{yr:2023,mo:2, self:19,staff:12},
          {yr:2023,mo:3, self:20,staff:13},{yr:2023,mo:4, self:21,staff:14},
          {yr:2023,mo:5, self:22,staff:15},{yr:2023,mo:6, self:23,staff:16},
          {yr:2023,mo:7, self:24,staff:17},{yr:2023,mo:8, self:25,staff:18},
          {yr:2023,mo:9, self:26,staff:19},{yr:2023,mo:10,self:27,staff:20},
          {yr:2023,mo:11,self:28,staff:21},{yr:2023,mo:12,self:30,staff:22},
          // 2024
          {yr:2024,mo:1, self:21,staff:13},{yr:2024,mo:2, self:22,staff:14},
          {yr:2024,mo:3, self:23,staff:15},{yr:2024,mo:4, self:24,staff:16},
          {yr:2024,mo:5, self:25,staff:17},{yr:2024,mo:6, self:26,staff:18},
          {yr:2024,mo:7, self:27,staff:19},{yr:2024,mo:8, self:28,staff:20},
          {yr:2024,mo:9, self:29,staff:21},{yr:2024,mo:10,self:30,staff:22},
          {yr:2024,mo:11,self:31,staff:23},{yr:2024,mo:12,self:32,staff:24},
          // 2025
          {yr:2025,mo:1, self:23,staff:14},{yr:2025,mo:2, self:24,staff:15},
          {yr:2025,mo:3, self:25,staff:16},{yr:2025,mo:4, self:26,staff:17},
          {yr:2025,mo:5, self:27,staff:18},{yr:2025,mo:6, self:28,staff:19},
          {yr:2025,mo:7, self:29,staff:20},{yr:2025,mo:8, self:30,staff:21},
          {yr:2025,mo:9, self:31,staff:22},{yr:2025,mo:10,self:32,staff:23},
          {yr:2025,mo:11,self:33,staff:24},{yr:2025,mo:12,self:35,staff:26},
          // 2026 Jan–Mar
          {yr:2026,mo:1, self:25,staff:15},{yr:2026,mo:2, self:26,staff:16},
          {yr:2026,mo:3, self:27,staff:17},
        ];
        const ageGroups = ["10","22","30","40","55"];
        const items: any[] = [];
        // Always include both month_index and year_index so the component can
        // aggregate by year-month regardless of whether the range spans multiple years.
        MONTHLY.filter(d => inRange(d.yr, d.mo)).forEach(({ yr, mo, self, staff }) => {
          for (let i = 0; i < self;  i++) items.push({ source:"Self-Booking",  patient_age:ageGroups[i%5], month_index:String(mo), year_index:String(yr) });
          for (let i = 0; i < staff; i++) items.push({ source:"Staff-Booking", patient_age:ageGroups[i%5], month_index:String(mo), year_index:String(yr) });
        });
        return [{ items }];
      }

      // ── appointment-success ─────────────────────────────────────────────
      case "appointment-success": {
        const MONTHLY = [
          // 2022 (~12% no-show)
          {yr:2022,mo:1, total:65,noshow:8 },{yr:2022,mo:2, total:62,noshow:7 },
          {yr:2022,mo:3, total:68,noshow:8 },{yr:2022,mo:4, total:72,noshow:9 },
          {yr:2022,mo:5, total:70,noshow:8 },{yr:2022,mo:6, total:75,noshow:9 },
          {yr:2022,mo:7, total:78,noshow:9 },{yr:2022,mo:8, total:74,noshow:9 },
          {yr:2022,mo:9, total:72,noshow:9 },{yr:2022,mo:10,total:70,noshow:8 },
          {yr:2022,mo:11,total:73,noshow:9 },{yr:2022,mo:12,total:80,noshow:10},
          // 2023 (~11% no-show)
          {yr:2023,mo:1, total:72,noshow:8 },{yr:2023,mo:2, total:68,noshow:7 },
          {yr:2023,mo:3, total:75,noshow:8 },{yr:2023,mo:4, total:80,noshow:9 },
          {yr:2023,mo:5, total:78,noshow:8 },{yr:2023,mo:6, total:82,noshow:9 },
          {yr:2023,mo:7, total:85,noshow:9 },{yr:2023,mo:8, total:82,noshow:9 },
          {yr:2023,mo:9, total:80,noshow:8 },{yr:2023,mo:10,total:77,noshow:8 },
          {yr:2023,mo:11,total:81,noshow:9 },{yr:2023,mo:12,total:88,noshow:10},
          // 2024 (~10% no-show)
          {yr:2024,mo:1, total:80,noshow:8 },{yr:2024,mo:2, total:75,noshow:7 },
          {yr:2024,mo:3, total:82,noshow:8 },{yr:2024,mo:4, total:88,noshow:9 },
          {yr:2024,mo:5, total:85,noshow:8 },{yr:2024,mo:6, total:90,noshow:9 },
          {yr:2024,mo:7, total:92,noshow:9 },{yr:2024,mo:8, total:88,noshow:9 },
          {yr:2024,mo:9, total:86,noshow:8 },{yr:2024,mo:10,total:84,noshow:8 },
          {yr:2024,mo:11,total:87,noshow:9 },{yr:2024,mo:12,total:95,noshow:10},
          // 2025 (~9% no-show)
          {yr:2025,mo:1, total:86,noshow:8 },{yr:2025,mo:2, total:81,noshow:7 },
          {yr:2025,mo:3, total:89,noshow:8 },{yr:2025,mo:4, total:95,noshow:9 },
          {yr:2025,mo:5, total:92,noshow:8 },{yr:2025,mo:6, total:97,noshow:9 },
          {yr:2025,mo:7, total:99,noshow:9 },{yr:2025,mo:8, total:95,noshow:9 },
          {yr:2025,mo:9, total:93,noshow:8 },{yr:2025,mo:10,total:91,noshow:8 },
          {yr:2025,mo:11,total:94,noshow:8 },{yr:2025,mo:12,total:103,noshow:9},
          // 2026 Jan–Mar (~8% no-show)
          {yr:2026,mo:1, total:93,noshow:7 },{yr:2026,mo:2, total:87,noshow:7 },
          {yr:2026,mo:3, total:96,noshow:8 },
        ];
        const items: any[] = [];
        MONTHLY.filter(d => inRange(d.yr, d.mo)).forEach(({ yr, mo, total, noshow }) => {
          for (let i = 0; i < total; i++)
            items.push({ year_ce:String(yr), month_index:String(mo), is_no_show: i < noshow ? "1" : "0" });
        });
        return [{ items }];
      }

      // ── appointment-cancel ──────────────────────────────────────────────
      case "appointment-cancel": {
        const DATA = [
          // 2022
          {yr:2022,mo:1, cancelled_by_patient:"10",cancelled_by_staff:"5" },
          {yr:2022,mo:2, cancelled_by_patient:"8", cancelled_by_staff:"4" },
          {yr:2022,mo:3, cancelled_by_patient:"12",cancelled_by_staff:"6" },
          {yr:2022,mo:4, cancelled_by_patient:"14",cancelled_by_staff:"7" },
          {yr:2022,mo:5, cancelled_by_patient:"11",cancelled_by_staff:"5" },
          {yr:2022,mo:6, cancelled_by_patient:"15",cancelled_by_staff:"8" },
          {yr:2022,mo:7, cancelled_by_patient:"17",cancelled_by_staff:"6" },
          {yr:2022,mo:8, cancelled_by_patient:"13",cancelled_by_staff:"6" },
          {yr:2022,mo:9, cancelled_by_patient:"11",cancelled_by_staff:"5" },
          {yr:2022,mo:10,cancelled_by_patient:"9", cancelled_by_staff:"4" },
          {yr:2022,mo:11,cancelled_by_patient:"14",cancelled_by_staff:"7" },
          {yr:2022,mo:12,cancelled_by_patient:"18",cancelled_by_staff:"9" },
          // 2023
          {yr:2023,mo:1, cancelled_by_patient:"12",cancelled_by_staff:"6" },
          {yr:2023,mo:2, cancelled_by_patient:"10",cancelled_by_staff:"5" },
          {yr:2023,mo:3, cancelled_by_patient:"14",cancelled_by_staff:"7" },
          {yr:2023,mo:4, cancelled_by_patient:"16",cancelled_by_staff:"8" },
          {yr:2023,mo:5, cancelled_by_patient:"13",cancelled_by_staff:"6" },
          {yr:2023,mo:6, cancelled_by_patient:"18",cancelled_by_staff:"9" },
          {yr:2023,mo:7, cancelled_by_patient:"20",cancelled_by_staff:"8" },
          {yr:2023,mo:8, cancelled_by_patient:"15",cancelled_by_staff:"7" },
          {yr:2023,mo:9, cancelled_by_patient:"12",cancelled_by_staff:"6" },
          {yr:2023,mo:10,cancelled_by_patient:"11",cancelled_by_staff:"5" },
          {yr:2023,mo:11,cancelled_by_patient:"16",cancelled_by_staff:"8" },
          {yr:2023,mo:12,cancelled_by_patient:"22",cancelled_by_staff:"11"},
          // 2024
          {yr:2024,mo:1, cancelled_by_patient:"15",cancelled_by_staff:"8" },
          {yr:2024,mo:2, cancelled_by_patient:"12",cancelled_by_staff:"6" },
          {yr:2024,mo:3, cancelled_by_patient:"18",cancelled_by_staff:"9" },
          {yr:2024,mo:4, cancelled_by_patient:"20",cancelled_by_staff:"11"},
          {yr:2024,mo:5, cancelled_by_patient:"17",cancelled_by_staff:"7" },
          {yr:2024,mo:6, cancelled_by_patient:"22",cancelled_by_staff:"12"},
          {yr:2024,mo:7, cancelled_by_patient:"25",cancelled_by_staff:"10"},
          {yr:2024,mo:8, cancelled_by_patient:"19",cancelled_by_staff:"9" },
          {yr:2024,mo:9, cancelled_by_patient:"16",cancelled_by_staff:"8" },
          {yr:2024,mo:10,cancelled_by_patient:"14",cancelled_by_staff:"7" },
          {yr:2024,mo:11,cancelled_by_patient:"21",cancelled_by_staff:"11"},
          {yr:2024,mo:12,cancelled_by_patient:"28",cancelled_by_staff:"14"},
          // 2025
          {yr:2025,mo:1, cancelled_by_patient:"16",cancelled_by_staff:"9" },
          {yr:2025,mo:2, cancelled_by_patient:"13",cancelled_by_staff:"7" },
          {yr:2025,mo:3, cancelled_by_patient:"19",cancelled_by_staff:"10"},
          {yr:2025,mo:4, cancelled_by_patient:"22",cancelled_by_staff:"12"},
          {yr:2025,mo:5, cancelled_by_patient:"18",cancelled_by_staff:"8" },
          {yr:2025,mo:6, cancelled_by_patient:"24",cancelled_by_staff:"13"},
          {yr:2025,mo:7, cancelled_by_patient:"27",cancelled_by_staff:"11"},
          {yr:2025,mo:8, cancelled_by_patient:"21",cancelled_by_staff:"10"},
          {yr:2025,mo:9, cancelled_by_patient:"17",cancelled_by_staff:"9" },
          {yr:2025,mo:10,cancelled_by_patient:"15",cancelled_by_staff:"8" },
          {yr:2025,mo:11,cancelled_by_patient:"23",cancelled_by_staff:"12"},
          {yr:2025,mo:12,cancelled_by_patient:"30",cancelled_by_staff:"15"},
          // 2026 Jan–Mar
          {yr:2026,mo:1, cancelled_by_patient:"17",cancelled_by_staff:"9" },
          {yr:2026,mo:2, cancelled_by_patient:"14",cancelled_by_staff:"8" },
          {yr:2026,mo:3, cancelled_by_patient:"21",cancelled_by_staff:"11"},
        ];
        return [{ items: DATA.filter(d => inRange(d.yr, d.mo))
          .map(({ yr, mo, ...rest }) => ({ year_ce:String(yr), month_index:String(mo), ...rest })) }];
      }

      // ── appointment-cancel-3year ────────────────────────────────────────
      case "appointment-cancel-3year": {
        const YEARS = [
          {year_ce:"2022",cancelled_by_patient:"150",cancelled_by_staff:"80" },
          {year_ce:"2023",cancelled_by_patient:"168",cancelled_by_staff:"88" },
          {year_ce:"2024",cancelled_by_patient:"227",cancelled_by_staff:"112"},
          {year_ce:"2025",cancelled_by_patient:"245",cancelled_by_staff:"124"},
          {year_ce:"2026",cancelled_by_patient:"52", cancelled_by_staff:"28" },
        ];
        return [{ items: YEARS
          .filter(d => parseInt(d.year_ce) >= startYearNum && parseInt(d.year_ce) <= endYearNum)
          .map(d => {
            const frac = monthFraction(parseInt(d.year_ce));
            return {
              year_ce: d.year_ce,
              cancelled_by_patient: String(Math.round(parseInt(d.cancelled_by_patient) * frac)),
              cancelled_by_staff:   String(Math.round(parseInt(d.cancelled_by_staff)   * frac)),
            };
          })
        }];
      }

      // ── traffic-24hour ──────────────────────────────────────────────────
      case "traffic-24hour": {
        // Walk-in / encounter patterns — higher volume, varied yearly shapes
        const HOURLY: Record<number,number[]> = {
          2022:[0,0,0,0,0,0,0,38,72,85,78,62,45,48,55,60,52,40,28,18,0,0,0,0], // bell peak 09:00
          2023:[0,0,0,0,0,0,0,35,65,88,72,55,40,52,80,85,68,45,30,20,0,0,0,0], // bimodal 09:00 & 15:00
          2024:[0,0,0,0,0,0,0,42,68,82,85,83,80,78,82,80,70,50,32,22,0,0,0,0], // plateau 09:00–15:00
          2025:[0,0,0,0,0,0,0,30,55,75,95,98,88,80,72,65,58,48,35,22,0,0,0,0], // late peak 10:00–11:00
          2026:[0,0,0,0,0,0,0,58,95,110,98,80,65,68,72,70,58,42,25,15,0,0,0,0], // early peak 08:00–09:00
        };
        const MONTH_WEIGHT = [0.85,0.80,0.95,1.00,1.05,1.10,1.10,1.05,1.05,1.10,1.00,0.95];
        const h = Array(24).fill(0) as number[];
        for (let yr = startYearNum; yr <= endYearNum; yr++) {
          const base = HOURLY[yr] ?? HOURLY[2026];
          const moStart = yr === startYearNum ? startMonthNum : 1;
          const moEnd   = yr === endYearNum   ? endMonthNum   : 12;
          let scale = 0;
          for (let mo = moStart; mo <= moEnd; mo++) scale += MONTH_WEIGHT[mo - 1];
          scale /= 12;
          base.forEach((cnt, i) => { h[i] += Math.round(cnt * scale); });
        }
        return [{ items: h.map((cnt, i) => ({
          time_label:`${String(i).padStart(2,"0")}:00:00`, total_count:String(cnt), count:String(cnt), sort_order:i, category:"Overall",
        }))}];
      }

      // ── appointment-24hour ──────────────────────────────────────────────
      case "appointment-24hour": {
        // Scheduled appointment patterns — lower volume, structured slot peaks
        const HOURLY: Record<number,number[]> = {
          2022:[0,0,0,0,0,0,0,20,55,72,68,45,30,35,60,65,50,35,20,10,0,0,0,0], // bimodal 09:00 & 14:00–15:00 slots
          2023:[0,0,0,0,0,0,0,25,68,82,78,55,35,30,38,42,38,28,18,10,0,0,0,0], // morning block 09:00–11:00
          2024:[0,0,0,0,0,0,0,22,58,75,70,60,35,38,65,68,52,38,22,12,0,0,0,0], // triple peaks 09:00/11:00/14:00
          2025:[0,0,0,0,0,0,0,18,48,65,68,65,62,60,62,65,60,48,32,18,0,0,0,0], // even spread 09:00–16:00
          2026:[0,0,0,0,0,0,0,28,75,92,88,68,42,35,40,45,38,28,18,10,0,0,0,0], // concentrated early 08:00–10:00
        };
        const MONTH_WEIGHT = [0.88,0.82,0.96,1.00,1.04,1.08,1.06,1.02,1.06,1.08,1.02,0.98];
        const h = Array(24).fill(0) as number[];
        for (let yr = startYearNum; yr <= endYearNum; yr++) {
          const base = HOURLY[yr] ?? HOURLY[2026];
          const moStart = yr === startYearNum ? startMonthNum : 1;
          const moEnd   = yr === endYearNum   ? endMonthNum   : 12;
          let scale = 0;
          for (let mo = moStart; mo <= moEnd; mo++) scale += MONTH_WEIGHT[mo - 1];
          scale /= 12;
          base.forEach((cnt, i) => { h[i] += Math.round(cnt * scale); });
        }
        return [{ items: h.map((cnt, i) => ({
          time_label:`${String(i).padStart(2,"0")}:00:00`, total_count:String(cnt), count:String(cnt), sort_order:i, category:"Overall",
        }))}];
      }

      // ── traffic-24hour-quarter ──────────────────────────────────────
      case "traffic-24hour-quarter": {
        // Walk-in quarterly shapes — driven by seasonal foot-traffic patterns
        const Q_HOURLY: Record<string, number[]> = {
          Q1: [0,0,0,0,0,0,0,48,90,92,74,58,42,44,50,54,48,38,26,14,0,0,0,0], // winter: early sharp peak 08:00
          Q2: [0,0,0,0,0,0,0,38,70,95,98,82,62,65,70,72,65,50,34,20,0,0,0,0], // spring: bell peak 09:00-10:00
          Q3: [0,0,0,0,0,0,0,30,55,85,68,48,35,50,85,92,72,55,40,25,0,0,0,0], // summer: bimodal 09:00 & 14:00-15:00
          Q4: [0,0,0,0,0,0,0,35,60,78,85,83,78,76,82,90,86,68,48,28,0,0,0,0], // autumn: plateau, afternoon-shifted
        };
        const YEAR_FACTOR: Record<number, number> = { 2022:0.82, 2023:0.91, 2024:1.00, 2025:1.08, 2026:1.16 };
        const yf = YEAR_FACTOR[endYearNum] ?? 1.0;
        const qMonths = [[1,2,3],[4,5,6],[7,8,9],[10,11,12]];
        const items: any[] = [];
        ["Q1","Q2","Q3","Q4"].forEach((q, qi) => {
          const overlap = qMonths[qi].filter(mo => inRange(endYearNum, mo)).length;
          if (overlap === 0) return;
          const scale = (overlap / 3) * yf;
          Q_HOURLY[q].forEach((cnt, i) => {
            const v = String(Math.round(cnt * scale));
            items.push({ time_label:`${String(i).padStart(2,"0")}:00:00`, total_count:v, count:v, sort_order:i, category:q });
          });
        });
        return [{ items }];
      }

      // ── appointment-24hour-quarter ──────────────────────────────────
      case "appointment-24hour-quarter": {
        // Scheduled appointment quarterly shapes — slot-based, lower volume
        const Q_HOURLY: Record<string, number[]> = {
          Q1: [0,0,0,0,0,0,0,35,72,85,80,60,38,32,38,42,38,28,18,10,0,0,0,0], // winter: morning health-check surge
          Q2: [0,0,0,0,0,0,0,25,58,75,72,65,45,45,55,58,50,38,25,14,0,0,0,0], // spring: balanced morning spread
          Q3: [0,0,0,0,0,0,0,20,45,70,60,40,28,42,72,78,58,42,28,15,0,0,0,0], // summer: bimodal 09:00 & 14:00-15:00
          Q4: [0,0,0,0,0,0,0,28,52,65,72,68,62,58,65,75,78,60,42,22,0,0,0,0], // autumn: afternoon year-end check-ups
        };
        const YEAR_FACTOR: Record<number, number> = { 2022:0.80, 2023:0.90, 2024:1.00, 2025:1.10, 2026:1.20 };
        const yf = YEAR_FACTOR[endYearNum] ?? 1.0;
        const qMonths = [[1,2,3],[4,5,6],[7,8,9],[10,11,12]];
        const items: any[] = [];
        ["Q1","Q2","Q3","Q4"].forEach((q, qi) => {
          const overlap = qMonths[qi].filter(mo => inRange(endYearNum, mo)).length;
          if (overlap === 0) return;
          const scale = (overlap / 3) * yf;
          Q_HOURLY[q].forEach((cnt, i) => {
            const v = String(Math.round(cnt * scale));
            items.push({ time_label:`${String(i).padStart(2,"0")}:00:00`, total_count:v, count:v, sort_order:i, category:q });
          });
        });
        return [{ items }];
      }

      // ── traffic-24hour-3-year ─────────────────────────────────────────
      case "traffic-24hour-3-year": {
        // Walk-in yearly shapes — distinct per-year patterns
        const HOURLY: Record<number, number[]> = {
          2022:[0,0,0,0,0,0,0,38,72,85,78,62,45,48,55,60,52,40,28,18,0,0,0,0], // bell peak 09:00
          2023:[0,0,0,0,0,0,0,35,65,88,72,55,40,52,80,85,68,45,30,20,0,0,0,0], // bimodal 09:00 & 15:00
          2024:[0,0,0,0,0,0,0,42,68,82,85,83,80,78,82,80,70,50,32,22,0,0,0,0], // plateau 09:00-15:00
          2025:[0,0,0,0,0,0,0,30,55,75,95,98,88,80,72,65,58,48,35,22,0,0,0,0], // late peak 10:00-11:00
          2026:[0,0,0,0,0,0,0,58,95,110,98,80,65,68,72,70,58,42,25,15,0,0,0,0], // early peak 08:00-09:00
        };
        const items: any[] = [];
        for (let yr = startYearNum; yr <= endYearNum; yr++) {
          const frac = monthFraction(yr);
          (HOURLY[yr] ?? HOURLY[2026]).forEach((cnt, i) => {
            const v = String(Math.round(cnt * frac));
            items.push({ time_label:`${String(i).padStart(2,"0")}:00:00`, total_count:v, count:v, sort_order:i, category:String(yr) });
          });
        }
        return [{ items }];
      }

      // ── appointment-24hour-3-year ─────────────────────────────────────
      case "appointment-24hour-3-year": {
        // Scheduled appointment yearly shapes — slot-based, lower volume per year
        const HOURLY: Record<number, number[]> = {
          2022:[0,0,0,0,0,0,0,20,55,72,68,45,30,35,60,65,50,35,20,10,0,0,0,0], // bimodal 09:00 & 14:00-15:00 slots
          2023:[0,0,0,0,0,0,0,25,68,82,78,55,35,30,38,42,38,28,18,10,0,0,0,0], // morning block 09:00-11:00
          2024:[0,0,0,0,0,0,0,22,58,75,70,60,35,38,65,68,52,38,22,12,0,0,0,0], // triple peaks 09:00/11:00/14:00
          2025:[0,0,0,0,0,0,0,18,48,65,68,65,62,60,62,65,60,48,32,18,0,0,0,0], // even spread 09:00-16:00
          2026:[0,0,0,0,0,0,0,28,75,92,88,68,42,35,40,45,38,28,18,10,0,0,0,0], // concentrated early 08:00-10:00
        };
        const items: any[] = [];
        for (let yr = startYearNum; yr <= endYearNum; yr++) {
          const frac = monthFraction(yr);
          (HOURLY[yr] ?? HOURLY[2026]).forEach((cnt, i) => {
            const v = String(Math.round(cnt * frac));
            items.push({ time_label:`${String(i).padStart(2,"0")}:00:00`, total_count:v, count:v, sort_order:i, category:String(yr) });
          });
        }
        return [{ items }];
      }

      // ── summary-overview ─────────────────────────────────────────────
      case "summary-overview": {
        const MONTHLY: Record<number, {mo:number,total_sales:string}[]> = {
          2022:[{mo:1,total_sales:"95000"},{mo:2,total_sales:"88000"},{mo:3,total_sales:"102000"},{mo:4,total_sales:"78000"},{mo:5,total_sales:"110000"},{mo:6,total_sales:"125000"},{mo:7,total_sales:"145000"},{mo:8,total_sales:"122000"},{mo:9,total_sales:"115000"},{mo:10,total_sales:"108000"},{mo:11,total_sales:"132000"},{mo:12,total_sales:"155000"}],
          2023:[{mo:1,total_sales:"102000"},{mo:2,total_sales:"96000"},{mo:3,total_sales:"115000"},{mo:4,total_sales:"88000"},{mo:5,total_sales:"120000"},{mo:6,total_sales:"138000"},{mo:7,total_sales:"160000"},{mo:8,total_sales:"135000"},{mo:9,total_sales:"128000"},{mo:10,total_sales:"118000"},{mo:11,total_sales:"145000"},{mo:12,total_sales:"172000"}],
          2024:[{mo:1,total_sales:"120000"},{mo:2,total_sales:"110000"},{mo:3,total_sales:"132000"},{mo:4,total_sales:"100000"},{mo:5,total_sales:"140000"},{mo:6,total_sales:"158000"},{mo:7,total_sales:"182000"},{mo:8,total_sales:"155000"},{mo:9,total_sales:"147000"},{mo:10,total_sales:"135000"},{mo:11,total_sales:"165000"},{mo:12,total_sales:"195000"}],
          2025:[{mo:1,total_sales:"130000"},{mo:2,total_sales:"120000"},{mo:3,total_sales:"145000"},{mo:4,total_sales:"110000"},{mo:5,total_sales:"155000"},{mo:6,total_sales:"175000"},{mo:7,total_sales:"200000"},{mo:8,total_sales:"170000"},{mo:9,total_sales:"162000"},{mo:10,total_sales:"148000"},{mo:11,total_sales:"180000"},{mo:12,total_sales:"215000"}],
          2026:[{mo:1,total_sales:"140000"},{mo:2,total_sales:"128000"},{mo:3,total_sales:"158000"}],
        };
        const yearData = MONTHLY[startYearNum] ?? MONTHLY[2026];
        return [{ items: yearData
          .filter(d => inRange(startYearNum, d.mo))
          .map(({ mo, ...rest }) => ({ month: String(mo), ...rest })) }];
      }

      // ── summary-overview-3year ───────────────────────────────────────
      case "summary-overview-3year": {
        // Seasonal revenue base for the reference (end) year — any year range works
        const SEASONAL: Record<number, number> = {
          1: 130000, 2: 120000, 3: 145000,  4: 110000, 5: 155000,  6: 175000,
          7: 200000, 8: 170000, 9: 162000, 10: 148000, 11: 180000, 12: 215000,
        };
        const GROWTH_PER_YEAR = 0.08; // 8% growth per year — older years scale down
        const items: any[] = [];
        for (let yr = startYearNum; yr <= endYearNum; yr++) {
          const yearsBack = endYearNum - yr;
          const factor = Math.pow(1 - GROWTH_PER_YEAR, yearsBack);
          for (let mo = 1; mo <= 12; mo++) {
            if (inRange(yr, mo)) {
              const total_sales = Math.round((SEASONAL[mo] || 150000) * factor);
              items.push({ year: String(yr), month: String(mo), total_sales: String(total_sales) });
            }
          }
        }
        return [{ items }];
      }

      // ── summary-product-top5 ─────────────────────────────────────────
      case "summary-product-top5": {
        const isPopular = params.category === 'popular';
        const valueKey = isPopular ? 'total_sold' : 'total_price';
        return [{ items: [
          { pricing_name: "Complete Blood Count (CBC)", [valueKey]: isPopular ? "190" : "17000" },
          { pricing_name: "Thyroid Function Tests",     [valueKey]: isPopular ? "170" : "11000" },
          { pricing_name: "Lipid Profile",              [valueKey]: isPopular ? "125" : "19000" },
          { pricing_name: "Sputum Examination",         [valueKey]: isPopular ? "110" : "6500"  },
          { pricing_name: "Wound Swab Culture",         [valueKey]: isPopular ? "65"  : "12500" },
        ]}];
      }

      // ── summary-product-top3-year ────────────────────────────────────
      case "summary-product-top3-year": {
        const isPopular = params.category === 'popular';
        const valueKey = isPopular ? 'total_sold' : 'total_price';
        const RAW: any[] = [
          { year: 2024, product_name: "สระ ไดร์ เซตทรง",    [valueKey]: isPopular ? 920  : 18000, rank_position: 1 },
          { year: 2024, product_name: "นวดอโรม่าร้อน",       [valueKey]: isPopular ? 850  : 15000, rank_position: 2 },
          { year: 2024, product_name: "นวดเท้าและกดจุด",     [valueKey]: isPopular ? 650  : 10000, rank_position: 3 },
          { year: 2025, product_name: "สระ ไดร์ เซตทรง",    [valueKey]: isPopular ? 980  : 19500, rank_position: 1 },
          { year: 2025, product_name: "นวดอโรม่าร้อน",       [valueKey]: isPopular ? 880  : 16500, rank_position: 2 },
          { year: 2025, product_name: "นวดเท้าและกดจุด",     [valueKey]: isPopular ? 780  : 12500, rank_position: 3 },
          { year: 2026, product_name: "สระ ไดร์ เซตทรง",    [valueKey]: isPopular ? 250  : 5000,  rank_position: 1 },
          { year: 2026, product_name: "นวดอโรม่าร้อน",       [valueKey]: isPopular ? 220  : 4200,  rank_position: 2 },
          { year: 2026, product_name: "นวดเท้าและกดจุด",     [valueKey]: isPopular ? 180  : 3500,  rank_position: 3 },
        ];
        const items = RAW.filter(d => d.year >= startYearNum && d.year <= endYearNum);
        return [{ items }];
      }

      // ── summary-product-monthly ──────────────────────────────────────
      case "summary-product-monthly": {
        const MONTHLY = [
          {year:2022,month:1, total_sold:"35",total_price:"87500"}, {year:2022,month:2, total_sold:"28",total_price:"70000"}, {year:2022,month:3, total_sold:"42",total_price:"105000"},
          {year:2022,month:4, total_sold:"38",total_price:"95000"}, {year:2022,month:5, total_sold:"45",total_price:"112500"},{year:2022,month:6, total_sold:"52",total_price:"130000"},
          {year:2022,month:7, total_sold:"60",total_price:"150000"},{year:2022,month:8, total_sold:"50",total_price:"125000"},{year:2022,month:9, total_sold:"48",total_price:"120000"},
          {year:2022,month:10,total_sold:"44",total_price:"110000"},{year:2022,month:11,total_sold:"55",total_price:"137500"},{year:2022,month:12,total_sold:"65",total_price:"162500"},
          {year:2023,month:1, total_sold:"38",total_price:"95000"}, {year:2023,month:2, total_sold:"32",total_price:"80000"}, {year:2023,month:3, total_sold:"48",total_price:"120000"},
          {year:2023,month:4, total_sold:"42",total_price:"105000"},{year:2023,month:5, total_sold:"50",total_price:"125000"},{year:2023,month:6, total_sold:"58",total_price:"145000"},
          {year:2023,month:7, total_sold:"68",total_price:"170000"},{year:2023,month:8, total_sold:"56",total_price:"140000"},{year:2023,month:9, total_sold:"52",total_price:"130000"},
          {year:2023,month:10,total_sold:"48",total_price:"120000"},{year:2023,month:11,total_sold:"60",total_price:"150000"},{year:2023,month:12,total_sold:"72",total_price:"180000"},
          {year:2024,month:1, total_sold:"42",total_price:"105000"},{year:2024,month:2, total_sold:"36",total_price:"90000"}, {year:2024,month:3, total_sold:"55",total_price:"137500"},
          {year:2024,month:4, total_sold:"48",total_price:"120000"},{year:2024,month:5, total_sold:"58",total_price:"145000"},{year:2024,month:6, total_sold:"65",total_price:"162500"},
          {year:2024,month:7, total_sold:"78",total_price:"195000"},{year:2024,month:8, total_sold:"62",total_price:"155000"},{year:2024,month:9, total_sold:"58",total_price:"145000"},
          {year:2024,month:10,total_sold:"52",total_price:"130000"},{year:2024,month:11,total_sold:"68",total_price:"170000"},{year:2024,month:12,total_sold:"82",total_price:"205000"},
          {year:2025,month:1, total_sold:"45",total_price:"112500"},{year:2025,month:2, total_sold:"38",total_price:"95000"}, {year:2025,month:3, total_sold:"58",total_price:"145000"},
          {year:2025,month:4, total_sold:"52",total_price:"130000"},{year:2025,month:5, total_sold:"62",total_price:"155000"},{year:2025,month:6, total_sold:"72",total_price:"180000"},
          {year:2025,month:7, total_sold:"85",total_price:"212500"},{year:2025,month:8, total_sold:"68",total_price:"170000"},{year:2025,month:9, total_sold:"64",total_price:"160000"},
          {year:2025,month:10,total_sold:"58",total_price:"145000"},{year:2025,month:11,total_sold:"75",total_price:"187500"},{year:2025,month:12,total_sold:"90",total_price:"225000"},
          {year:2026,month:1, total_sold:"48",total_price:"120000"},{year:2026,month:2, total_sold:"40",total_price:"100000"},{year:2026,month:3, total_sold:"62",total_price:"155000"},
        ];
        const filtered = MONTHLY.filter(d => inRange(d.year, d.month));
        return [{ items: filtered.map(({ year, month, total_sold, total_price }) => ({
          year: String(year),
          month,
          total_sold,
          total_price,
        }))}];
      }

      // ── summary-performance-rank5 ────────────────────────────────────
      case "summary-performance-rank5": {
        const RANK5: Record<number, any[]> = {
          2022: [
            { first_name: "สมชาย",    middle_name: "",    last_name: "ใจดี",       total_patient: "72" },
            { first_name: "สมศักดิ์",  middle_name: "",    last_name: "มั่นคง",     total_patient: "68" },
            { first_name: "อรุณ",     middle_name: "นภา", last_name: "แสงทอง",    total_patient: "65" },
            { first_name: "จอห์น",    middle_name: "",    last_name: "สมิธ",       total_patient: "60" },
            { first_name: "ฟารีดา",   middle_name: "",    last_name: "อับดุลบุตร", total_patient: "55" },
          ],
          2023: [
            { first_name: "pt",       middle_name: "",    last_name: "common",     total_patient: "80" },
            { first_name: "สมชาย",    middle_name: "",    last_name: "ใจดี",       total_patient: "76" },
            { first_name: "อรุณ",     middle_name: "นภา", last_name: "แสงทอง",    total_patient: "70" },
            { first_name: "ฟารีดา",   middle_name: "",    last_name: "อับดุลบุตร", total_patient: "62" },
            { first_name: "นักกายภาพ", middle_name: "",   last_name: "คนที่หนึ่ง", total_patient: "58" },
          ],
          2024: [
            { first_name: "pt",       middle_name: "",    last_name: "common",     total_patient: "88" },
            { first_name: "สมชาย",    middle_name: "",    last_name: "ใจดี",       total_patient: "82" },
            { first_name: "นักกายภาพ", middle_name: "",   last_name: "คนที่หนึ่ง", total_patient: "75" },
            { first_name: "อรุณ",     middle_name: "นภา", last_name: "แสงทอง",    total_patient: "70" },
            { first_name: "จอห์น",    middle_name: "",    last_name: "สมิธ",       total_patient: "65" },
          ],
          2025: [
            { first_name: "pt",       middle_name: "",    last_name: "common",     total_patient: "95" },
            { first_name: "สมศักดิ์",  middle_name: "",    last_name: "มั่นคง",     total_patient: "88" },
            { first_name: "อรุณ",     middle_name: "นภา", last_name: "แสงทอง",    total_patient: "85" },
            { first_name: "จอห์น",    middle_name: "",    last_name: "สมิธ",       total_patient: "82" },
            { first_name: "ฟารีดา",   middle_name: "",    last_name: "อับดุลบุตร", total_patient: "78" },
          ],
          2026: [
            { first_name: "pt",       middle_name: "",    last_name: "common",     total_patient: "30" },
            { first_name: "นักกายภาพ", middle_name: "",   last_name: "คนที่หนึ่ง", total_patient: "25" },
            { first_name: "ฟารีดา",   middle_name: "",    last_name: "อับดุลบุตร", total_patient: "22" },
            { first_name: "สมชาย",    middle_name: "",    last_name: "ใจดี",       total_patient: "20" },
            { first_name: "จอห์น",    middle_name: "",    last_name: "สมิธ",       total_patient: "18" },
          ],
        };
        return [{ items: RANK5[endYearNum] ?? RANK5[2026] }];
      }

      // ── summary-performance-rank3-year ───────────────────────────────
      case "summary-performance-rank3-year": {
        const RAW = [
          { year: 2022, first_name: "สมชาย",    middle_name: "",    last_name: "ใจดี",       total_patient: 320, rank_position: 1 },
          { year: 2022, first_name: "สมศักดิ์",  middle_name: "",    last_name: "มั่นคง",     total_patient: 290, rank_position: 2 },
          { year: 2022, first_name: "อรุณ",     middle_name: "นภา", last_name: "แสงทอง",    total_patient: 265, rank_position: 3 },
          { year: 2023, first_name: "pt",       middle_name: "",    last_name: "common",     total_patient: 380, rank_position: 1 },
          { year: 2023, first_name: "สมชาย",    middle_name: "",    last_name: "ใจดี",       total_patient: 340, rank_position: 2 },
          { year: 2023, first_name: "ฟารีดา",   middle_name: "",    last_name: "อับดุลบุตร", total_patient: 310, rank_position: 3 },
          { year: 2024, first_name: "pt",       middle_name: "",    last_name: "common",     total_patient: 450, rank_position: 1 },
          { year: 2024, first_name: "นักกายภาพ", middle_name: "",   last_name: "คนที่หนึ่ง", total_patient: 390, rank_position: 2 },
          { year: 2024, first_name: "สมชาย",    middle_name: "",    last_name: "ใจดี",       total_patient: 355, rank_position: 3 },
          { year: 2025, first_name: "pt",       middle_name: "",    last_name: "common",     total_patient: 50,  rank_position: 1 },
          { year: 2025, first_name: "นักกายภาพ", middle_name: "",   last_name: "คนที่หนึ่ง", total_patient: 7,   rank_position: 2 },
          { year: 2025, first_name: "ฟารีดา",   middle_name: "",    last_name: "อับดุลบุตร", total_patient: 6,   rank_position: 3 },
          { year: 2026, first_name: "pt",       middle_name: "",    last_name: "common",     total_patient: 140, rank_position: 1 },
          { year: 2026, first_name: "นักกายภาพ", middle_name: "",   last_name: "คนที่หนึ่ง", total_patient: 115, rank_position: 2 },
          { year: 2026, first_name: "ฟารีดา",   middle_name: "",    last_name: "อับดุลบุตร", total_patient: 98,  rank_position: 3 },
        ];
        const items = RAW.filter(d => d.year >= startYearNum && d.year <= endYearNum);
        return [{ items }];
      }

      // ── summary-performance-individual ───────────────────────────────
      case "summary-performance-individual": {
        const MONTHLY = [
          {year:2022,month:1,total_patient:28},{year:2022,month:2,total_patient:22},{year:2022,month:3,total_patient:32},
          {year:2022,month:4,total_patient:30},{year:2022,month:5,total_patient:35},{year:2022,month:6,total_patient:40},
          {year:2022,month:7,total_patient:45},{year:2022,month:8,total_patient:38},{year:2022,month:9,total_patient:36},
          {year:2022,month:10,total_patient:33},{year:2022,month:11,total_patient:42},{year:2022,month:12,total_patient:50},
          {year:2023,month:1,total_patient:32},{year:2023,month:2,total_patient:26},{year:2023,month:3,total_patient:38},
          {year:2023,month:4,total_patient:35},{year:2023,month:5,total_patient:42},{year:2023,month:6,total_patient:48},
          {year:2023,month:7,total_patient:55},{year:2023,month:8,total_patient:44},{year:2023,month:9,total_patient:40},
          {year:2023,month:10,total_patient:38},{year:2023,month:11,total_patient:48},{year:2023,month:12,total_patient:58},
          {year:2024,month:1,total_patient:38},{year:2024,month:2,total_patient:30},{year:2024,month:3,total_patient:45},
          {year:2024,month:4,total_patient:42},{year:2024,month:5,total_patient:50},{year:2024,month:6,total_patient:58},
          {year:2024,month:7,total_patient:65},{year:2024,month:8,total_patient:52},{year:2024,month:9,total_patient:48},
          {year:2024,month:10,total_patient:44},{year:2024,month:11,total_patient:55},{year:2024,month:12,total_patient:68},
          {year:2025,month:1,total_patient:42},{year:2025,month:2,total_patient:34},{year:2025,month:3,total_patient:50},
          {year:2025,month:4,total_patient:47},{year:2025,month:5,total_patient:56},{year:2025,month:6,total_patient:64},
          {year:2025,month:7,total_patient:72},{year:2025,month:8,total_patient:58},{year:2025,month:9,total_patient:54},
          {year:2025,month:10,total_patient:50},{year:2025,month:11,total_patient:62},{year:2025,month:12,total_patient:75},
          {year:2026,month:1,total_patient:45},{year:2026,month:2,total_patient:36},{year:2026,month:3,total_patient:53},
          {year:2026,month:4,total_patient:0},{year:2026,month:5,total_patient:0},{year:2026,month:6,total_patient:0},
          {year:2026,month:7,total_patient:0},{year:2026,month:8,total_patient:0},{year:2026,month:9,total_patient:0},
          {year:2026,month:10,total_patient:0},{year:2026,month:11,total_patient:0},{year:2026,month:12,total_patient:0},
        ];
        const items = MONTHLY.filter(d => inRange(d.year, d.month));
        return [{ items }];
      }
      default:
        break;
    }
  }

  let startDate = params.startDate?.split(" ")[0]
  let endDate = params.endDate?.split(" ")[0]

  switch (params.chart) {
    case "new-vs-old-patient":
      console.log(" new-vs-old-patient ");
      return await NewVsOldBreakMonthPipelineView.get({
        apiToken: controller.apiToken,
        extra: { division: divisionId },
        params: {
          ...(params.startDate && { start_date: startDate }),
          ...(params.endDate && { end_date: endDate }),
          division: divisionId,
        },
      });
    case "new-user":
      console.log(" new-user ");
      return await NewUserPipelineView.get({
        apiToken: controller.apiToken,
        extra: { division: divisionId },
        params: {
          ...(params.startDate && { start_date: startDate }),
          ...(params.endDate && { end_date: endDate }),
          division: divisionId,
        },
      });
    case "age-gender":
      console.log(" age-gender");
      return await DivideAgeRangeAndGenderPipelineView.get({
        apiToken: controller.apiToken,
        extra: { division: divisionId },
        params: {
          ...(params.startDate && { start_date: startDate }),
          ...(params.endDate && { end_date: endDate }),
          division: divisionId,
        },
      });
    case "new-user-age-gender":
      console.log(" new-user-age-gender");
      return await DivideAgeRangeAndGenderNewUserPipelineView.get({
        apiToken: controller.apiToken,
        extra: { division: divisionId },
        params: {
          ...(params.startDate && { start_date: startDate }),
          ...(params.endDate && { end_date: endDate }),
          division: divisionId,
        },
      });
    case "frequency-visit-within-six-month":
      console.log("frequency-visit-within-six-month");
      return await FrequencyVisitWithinSixMonthPipelineView.get({
        apiToken: controller.apiToken,
        extra: { division: divisionId },
        params: {
          ...(params.startDate && { start_date: startDate }),
          ...(params.endDate && { end_date: endDate }),
          division: divisionId,
        },
      });
    case "appointment-staff-vs-self":
      console.log("appointment-staff-vs-self");
      return await AppointmentStaffVsSelfPipelineView.get({
        apiToken: controller.apiToken,
        extra: { division: divisionId },
        params: {
          ...(params.startDate && { start_date: startDate }),
          ...(params.endDate && { end_date: endDate }),
          division: divisionId,
        },
      });
    case "appointment-success":
      console.log("aappointment-success");
      return await AppointmentSuccessPipelineView.get({
        apiToken: controller.apiToken,
        extra: { division: divisionId },
        params: {
          ...(params.startDate && { start_date: startDate }),
          ...(params.endDate && { end_date: endDate }),
          division: divisionId,
        },
      });
    case "appointment-cancel":
      console.log("appointment-cancel");
      return await AppointmentCancellationPipelineView.get({
        apiToken: controller.apiToken,
        extra: { division: divisionId },
        params: {
          ...(params.startDate && { start_date: startDate }),
          ...(params.endDate && { end_date: endDate }),
          division: divisionId,
        },
      });
    case "appointment-cancel-3year":
      console.log("appointment-cancel-3year");
      return await AppointmentCancellationThreeYearPipelineView.get({
        apiToken: controller.apiToken,
        extra: { division: divisionId },
        params: {
          ...(params.startDate && { start_date: startDate }),
          ...(params.endDate && { end_date: endDate }),
          division: divisionId,
        },
      });
    case "traffic-24hour":
      console.log("traffic-24hour");
      return await Encounter24HourPipelineView.get({
        apiToken: controller.apiToken,
        extra: { division: divisionId },
        params: {
          ...(params.startDate && { start_date: startDate }),
          ...(params.endDate && { end_date: endDate }),
          division: divisionId,
        },
      });
    case "traffic-24hour-quarter":
      console.log("traffic-24hour-quarter");
      return await Encounter24HourQuarterPipelineView.get({
        apiToken: controller.apiToken,
        extra: { division: divisionId },
        params: {
          ...(params.startDate && { start_date: startDate }),
          ...(params.endDate && { end_date: endDate }),
          division: divisionId,
        },
      });
    case "traffic-24hour-3-year":
      console.log("traffic-24hour-3-year");
      return await Encounter24HourThreeYearPipelineView.get({
        apiToken: controller.apiToken,
        extra: { division: divisionId },
        params: {
          ...(params.startDate && { start_date: startDate }),
          ...(params.endDate && { end_date: endDate }),
          division: divisionId,
        },
      });
    case "appointment-24hour":
      console.log("appointment-24hour");
      return await Appointment24HourPipelineView.get({
        apiToken: controller.apiToken,
        extra: { division: divisionId },
        params: {
          ...(params.startDate && { start_date: startDate }),
          ...(params.endDate && { end_date: endDate }),
          division: divisionId,
        },
      });
    case "appointment-24hour-quarter":
      console.log("appointment-24hour-quarter");
      return await Appointment24HourQuarterPipelineView.get({
        apiToken: controller.apiToken,
        extra: { division: divisionId },
        params: {
          ...(params.startDate && { start_date: startDate }),
          ...(params.endDate && { end_date: endDate }),
          division: divisionId,
        },
      });
    case "appointment-24hour-3-year":
      console.log("appointment-24hour-3-year");
      return await Appointment24HourThreeYearPipelineView.get({
        apiToken: controller.apiToken,
        extra: { division: divisionId },
        params: {
          ...(params.startDate && { start_date: startDate }),
          ...(params.endDate && { end_date: endDate }),
          division: divisionId,
        },
      });
    // ---- 
    case "summary-overview":
      console.log("summary-overview");

      return await SaleSummaryOverviewPipelineView.get({
        apiToken: controller.apiToken,
        extra: { division: divisionId },
        params: {
          ...(params.startDate && { start_year: startDate?.split("-")[0] }),
          ...(params.startDate && { start_month: startDate?.split("-")[1] }),
          ...(params.endDate && { end_year: endDate?.split("-")[0] }),
          ...(params.endDate && { end_month: endDate?.split("-")[1] }),
          division: divisionId,
        },
      });
    case "summary-overview-3year":
      console.log("summary-overview-3year");

      return await SaleSummaryOverviewThreeYearPipelineView.get({
        apiToken: controller.apiToken,
        extra: { division: divisionId },
        params: {
          // ...( params.startDate && { start_year: startDate?.split("-")[0] } ),
          ...(params.startDate && { start_month: startDate?.split("-")[1] }),
          ...(params.endDate && { year: endDate?.split("-")[0] }),
          ...(params.endDate && { end_month: endDate?.split("-")[1] }),
          division: divisionId,
        },
      });
    // ---- 
    case "summary-product-top5":
      console.log("summary-product-top5");
      if (params.category === "popular") {
        return await TopFivePopularProductPipelineView.get({
          apiToken: controller.apiToken,
          extra: { division: divisionId },
          params: {
            ...(params.startDate && { start_year: startDate?.split("-")[0] }),
            ...(params.startDate && { start_month: startDate?.split("-")[1] }),
            ...(params.endDate && { end_year: endDate?.split("-")[0] }),
            ...(params.endDate && { end_month: endDate?.split("-")[1] }),
            product_type: params.productType,
            division: divisionId,
          },
        });
      } else if (params.category === "revenue_max") {
        return await TopFiveProductByRevenuePipelineView.get({
          apiToken: controller.apiToken,
          extra: { division: divisionId },
          params: {
            ...(params.startDate && { start_year: startDate?.split("-")[0] }),
            ...(params.startDate && { start_month: startDate?.split("-")[1] }),
            ...(params.endDate && { end_year: endDate?.split("-")[0] }),
            ...(params.endDate && { end_month: endDate?.split("-")[1] }),
            product_type: params.productType,
            division: divisionId,
          },
        });
      }
      break;
    case "summary-product-top3-year":
      console.log("summary-product-top3-year");
      if (params.category === "popular") {
        return await TopThreePopularProductThreeYearPipelineView.get({
          apiToken: controller.apiToken,
          extra: { division: divisionId },
          params: {
            // ...(params.startDate && { start_year: startDate?.split("-")[0] }),
            // ...(params.startDate && { start_month: startDate?.split("-")[1] }),
            ...(params.endDate && { year: endDate?.split("-")[0] }),
            // ...(params.endDate && { end_month: endDate?.split("-")[1] }),
            product_type: params.productType,
            division: divisionId,
          },
        });
      } else if (params.category === "revenue_max") {
        return await TopThreeProductByRevenueThreeYearPipelineView.get({
          apiToken: controller.apiToken,
          extra: { division: divisionId },
          params: {
            // ...(params.startDate && { start_year: startDate?.split("-")[0] }),
            // ...(params.startDate && { start_month: startDate?.split("-")[1] }),
            ...(params.endDate && { year: endDate?.split("-")[0] }),
            // ...(params.endDate && { end_month: endDate?.split("-")[1] }),
            product_type: params.productType,
            division: divisionId,
          },
        });
      }
      break;

    case "summary-product-monthly":
      console.log("summary-product-monthly");
      if (params.category === "sales_sum") {
        return await ProductSoldAmountPipelineView.get({
          apiToken: controller.apiToken,
          extra: { division: divisionId },
          params: {
            ...(params.startDate && { start_year: startDate?.split("-")[0] }),
            ...(params.startDate && { start_month: startDate?.split("-")[1] }),
            ...(params.endDate && { end_year: endDate?.split("-")[0] }),
            ...(params.endDate && { end_month: endDate?.split("-")[1] }),
            product_id: params.productId,
            division: divisionId,
          },
        });
      } else if (params.category === "revenue_sum") {
        return await ProductSoldRevenuePipelineView.get({
          apiToken: controller.apiToken,
          extra: { division: divisionId },
          params: {
            ...(params.startDate && { start_year: startDate?.split("-")[0] }),
            ...(params.startDate && { start_month: startDate?.split("-")[1] }),
            ...(params.endDate && { end_year: endDate?.split("-")[0] }),
            ...(params.endDate && { end_month: endDate?.split("-")[1] }),
            product_id: params.productId,
            division: divisionId,
          },
        });
      }
      break;
    // ---- 
    case "summary-performance-rank5":
      console.log("summary-performance-rank5");
      return await TopFiveServiceProviderPipelineView.get({
        apiToken: controller.apiToken,
        extra: { division: divisionId },
        params: {
          ...(params.startDate && { start_year: startDate?.split("-")[0] }),
          ...(params.startDate && { start_month: startDate?.split("-")[1] }),
          ...(params.endDate && { end_year: endDate?.split("-")[0] }),
          ...(params.endDate && { end_month: endDate?.split("-")[1] }),
          division: divisionId,
        },
      });
    case "summary-performance-rank3-year":
      console.log("summary-performance-rank3-year");
      return await TopThreeServiceProviderThreeYearPipelineView.get({
        apiToken: controller.apiToken,
        extra: { division: divisionId },
        params: {
          // ...(params.startDate && { start_year: startDate?.split("-")[0] }),
          // ...(params.startDate && { start_month: startDate?.split("-")[1] }),
          ...(params.endDate && { year: endDate?.split("-")[0] }),
          // ...(params.endDate && { end_month: endDate?.split("-")[1] }),
          division: divisionId,
        },
      });
    case "summary-performance-individual":
      console.log("summary-performance-individual");
      return await ServiceProviderPerformanceSummaryPipelineView.get({
        apiToken: controller.apiToken,
        extra: { division: divisionId },
        params: {
          ...(params.startDate && { start_year: startDate?.split("-")[0] }),
          ...(params.startDate && { start_month: startDate?.split("-")[1] }),
          ...(params.endDate && { end_year: endDate?.split("-")[0] }),
          ...(params.endDate && { end_month: endDate?.split("-")[1] }),
          doctor_id: params.doctorId,
          division: divisionId,
        },
      });
    default:
      break;
  }
};

